var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0005 29.3337C17.4716 29.3337 18.6752 28.1029 18.6752 26.5986H13.3258C13.3258 28.1029 14.5294 29.3337 16.0005 29.3337ZM24.0246 21.1285V14.2909C24.0246 10.0926 21.8447 6.5781 18.0065 5.64819V4.71827C18.0065 3.58323 17.1105 2.66699 16.0005 2.66699C14.8905 2.66699 13.9945 3.58323 13.9945 4.71827V5.64819C10.1697 6.5781 7.97645 10.079 7.97645 14.2909V21.1285L5.30176 23.8636V25.2311H26.6993V23.8636L24.0246 21.1285ZM21.3499 22.4961H10.6511V14.2909C10.6511 10.8995 12.6705 8.13708 16.0005 8.13708C19.3305 8.13708 21.3499 10.8995 21.3499 14.2909V22.4961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationWhite);
export default __webpack_public_path__ + "static/media/notification-white.eccb592871690d978cee37d61250357d.svg";
export { ForwardRef as ReactComponent };